import SSE from '@/utils/http/sse'
import request from '@/utils/http/axios'
import { getSign } from '@/utils/getSign'

const baseURL = import.meta.env.VITE_BASE_API_URL

// 聊天
export const sendAiMessage = data => {
  return new SSE({
    url: `${baseURL}/chat/conversation/reply`,
    data: getSign(data)
  })
}

// 初始化
export const chatInit = data => {
  return request.post({ url: `${baseURL}/chat/conversation/start`, data })
}

// 消息历史
export const getChatMessage = data => {
  return request.post({ url: `${baseURL}/chat/conversation/getHistoryChat`, data })
}

// 猜你想问
export const getGuessYouWant = data => {
  return request.post({ url: `${baseURL}/recommended/getRecommendedQuestionByChat`, data })
}

export const stopMessageChat = data => {
  return request.post({ url: `${baseURL}/chat/conversation/stop`, data })
}

// 点赞/点踩/取消
export const addFeedback = data => {
  return request.post({ url: `${baseURL}/messageVote/add`, data })
}

// 查询用户所在区域
export const apiQueryUserLastDealRegion = params => {
  return request.get({
    url: `${baseURL}/user/queryUserLastDealRegion`,
    params
  })
}

// 以下接口为开源项目带来的，这些功能暂未用到

// 获取ws连接地址
export const getWsUrl = ({ openid }) => {
  return request.get({
    url: '/chat/getWsUrl',
    params: {
      openid,
      debug: import.meta.env.DEV ? 1 : 0
    }
  })
}

// 获取答案来源
export const getAnswerSource = params => {
  return request.get({ url: '/manage/getAnswerSource', params })
}

// 快捷指令
export const getFastCommandList = params => {
  return request.get({ url: '/chat/getFastCommandList', params })
}
